import React, { useEffect, useState } from "react";
import SelectPopover from "../../../components/UI/Form/Select/SelectPopover";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import PencilSVG from "../../../assets/svg/pencil.svg";
import TextField from "@mui/material/TextField";

const reportCreationMethodOptions = [
  {
    value: "１冊にまとめる",
    label: "１冊にまとめる",
  },
  {
    value: "検体別に作成する",
    label: "検体別に作成する",
  },
  {
    value: "その他",
    label: "その他",
  },
];

function PlanTableRow(props) {
  const { showEditOption, handleChangeField, reportPICInfo } = props;
  const [isShowEdit, setIsShowEdit] = useState(false);
  const [other, setOther] = useState(false);

  useEffect(() => {
    if (isShowEdit) {
      setOther(!reportCreationMethodOptions.some(item => item.value === reportPICInfo?.reportCreationMethod));
    } else {
      setOther(false);
    }
  }, [isShowEdit]);

  return (
    <div className={`w-full flex items-center pr-8 relative ${other ? 'h-20' : 'h-10'}`}>
      <div className="w-[25.5%] h-full">
        <div
          className={`w-full h-full border border-[#b3b3b3] bg-[#e0e4e5] flex items-center justify-center`}
        >
          <span className="text-custom-size">
            報告書作成方法
          </span>
        </div>
      </div>
      <div className="w-[74.5%] h-full">
        {isShowEdit ? (
          <>
            <div className="h-10">
              <SelectPopover
                selectedValue={other ? 'その他' : reportPICInfo?.reportCreationMethod}
                setSelectedValue={(newValue) => {
                  if (newValue === 'その他') {
                    setOther(true);
                    handleChangeField("reportCreationMethod", '')
                  } else {
                    setOther(false);
                    handleChangeField("reportCreationMethod", newValue)
                  }
                }}
                options={reportCreationMethodOptions}
              />
            </div>
            {other && (
              <TextField
                InputProps={{
                  style: {
                    borderRadius: "10px",
                    height: "40px",
                  },
                }}
                value={reportPICInfo?.reportCreationMethod}
                onChange={(newValue) => {
                  handleChangeField("reportCreationMethod", newValue.target.value);
                }}
                size="small"
                className="w-full h-full"
              />
            )}
          </>
        ) : (
          <div className="w-full h-full border border-[#B3B3B3] bg-[#e0e4e5] px-2 py-2.5 text-start">
            <p className="text-sm leading-[18px] tracking-[.2em] truncate">
              {reportPICInfo?.reportCreationMethod}
            </p>
          </div>
        )}
      </div>
      {showEditOption ? (
        <button
          type="button"
          onClick={() => setIsShowEdit(!isShowEdit)}
          className="absolute right-0 w-8 h-full flex items-center justify-center"
        >
          {isShowEdit ? (
            <FontAwesomeIcon icon={faCheck} size="lg"/>
          ) : (
            <img src={PencilSVG} className="" alt=""/>
          )}
        </button>
      ) : null}
    </div>
  );
}

export default PlanTableRow;
